import { useMutation, useQuery } from '@tanstack/react-query';

import reviewAnswerService from './reviewAnswerService';

import type {
    ReviewAnswer,
    ReviewAnswerUpdateRequest,
    ReviewAnswerWithQuestionnaireResponse,
} from '@/types/review/ReviewAnswer';

import { queryClient } from '@/AppWithProviders';
import { ReviewAnswerQueryKey, ReviewQueryKey } from '@/constants/QueryKeys';

const useGetReviewAnswer = ({ reviewAnswerId }: { reviewAnswerId: string }) => {
    return useQuery<
        ReviewAnswerWithQuestionnaireResponse,
        Error,
        ReviewAnswerWithQuestionnaireResponse
    >({
        queryKey: [ReviewAnswerQueryKey.REVIEW_ANSWER, reviewAnswerId],
        queryFn: () => reviewAnswerService.getReviewAnswer(reviewAnswerId),
        enabled: Boolean(reviewAnswerId),
    });
};

const useUpdateReviewAnswer = () => {
    return useMutation<ReviewAnswer, Error, ReviewAnswerUpdateRequest>({
        mutationFn: (reviewAnswer: ReviewAnswerUpdateRequest) =>
            reviewAnswerService.updateReviewAnswer(reviewAnswer),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [ReviewQueryKey.CYCLE_INSTANCE],
            });
        },
    });
};

export { useGetReviewAnswer, useUpdateReviewAnswer };
